export default __webpack_public_path__ + "static/cruwa-large-07b88222ab92d01cdf89201279f87eb5.png";